import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, CompanyService } from '../../../../_services';
import { BaseComponent } from '../../../../_components/base.component';

@Component({
  selector: 'header-primary-nav',
  templateUrl: './header-primary-nav.component.html',
  styleUrls: ['./header-primary-nav.component.scss'],
})
export class HeaderPrimaryNavComponent extends BaseComponent {
  @Input() fiscalYearId = '';

  private openSection: string | null = null;

  constructor(router: Router, authenticationService: AuthenticationService, companyService: CompanyService) {
    super(router, authenticationService, companyService);
  }

  getCurrentAgencyId(): string {
    const bureau = this.getBureau();
    if (bureau?.current_agency_id) { return bureau.current_agency_id; }
    const company = this.getCompany();
    return company?.current_agency_id;
  }

  toggle(section: string): void {
    this.openSection = this.openSection === section ? null : section;
  }

  isOpen(section: string): boolean {
    return this.openSection === section;
  }

  onCaret(section: string, event: Event): void {
    // Mobile only: the caret toggles the accordion instead of navigating.
    if (window.innerWidth < 768) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(section);
    }
  }
}
